import {
  Link,
  NavLink,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import "./recruitment_question_list.scss";
import RecruitmentQuestionList from "../../components/recruitment-question-list/RecruitmentQuestionList/RecruitmentQuestionList";
import React, { useEffect, useState } from "react";
import httpclient from "../../service/httpclient";
import {
  Avatar,
  Button,
  Empty,
  List,
  Modal,
  Space,
  Spin,
  Typography,
} from "antd";
import { ArrowRightOutlined, UserOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/zh-cn";

const RelatedNodesDisplay = React.memo(({ related_nodes }) => {
  const [isPossesCategory6, setIsPossessCategory6] = useState(false);
  useEffect(() => {
    if (!localStorage.token) return;
    httpclient.possessCategory(6, false).then((res) => {
      if (res) setIsPossessCategory6(res.result);
    });
  }, []);
  return (
    <div>
      <b style={{ fontSize: 18 }}>相关专栏</b>
      <List
        locale={{ emptyText: <Empty description="暂无推荐" /> }}
        dataSource={related_nodes}
        renderItem={(n) =>
          (n.id !== 57 || !isPossesCategory6) && (
            <List.Item>
              {(n.datatype === "zhuanlan" || n.datatype === "category") && (
                <List.Item.Meta
                  avatar={
                    <Avatar size={48} shape="square" src={n.detail.image} />
                  }
                  title={
                    <Link
                      to={`/${
                        n.datatype === "zhuanlan" ? "zhuanlans" : "categories"
                      }/${n.id}`}
                    >
                      {n.detail.name}
                    </Link>
                  }
                  description={
                    <Typography.Paragraph
                      style={{ marginBottom: 0, color: "grey" }}
                      ellipsis={{ rows: 2, expandable: true, symbol: "展开" }}
                    >
                      {n.detail.introduction_html}
                    </Typography.Paragraph>
                  }
                />
              )}
            </List.Item>
          )
        }
      />
    </div>
  );
});

const LatestExamRecordsDisplay = React.memo(({ listId }) => {
  const [records, setRecords] = useState(null);
  useEffect(() => {
    httpclient
      .getLatestRecruitmentQuestionExamRecordsByListId(listId)
      .then((res) => setRecords(res));
  }, [listId]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <b style={{ fontSize: 18 }}>近期笔试提交</b>
        <NavLink to={`/recruitment-question-exam-records/${listId}`}>
          查看我的
          <ArrowRightOutlined />
        </NavLink>
      </div>
      <List
        loading={records === null}
        locale={{ emptyText: <Empty description="暂无记录" /> }}
        dataSource={records ?? []}
        renderItem={(r) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 48,
                  }}
                >
                  <Avatar
                    size={40}
                    src={r.user.avatar}
                    icon={<UserOutlined />}
                  />
                </div>
              }
              title={r.user.name}
              description={`于 ${moment(r.created_at)
                .locale("zh-cn")
                .fromNow()} 提交了答卷`}
            />
          </List.Item>
        )}
      />
    </div>
  );
});

const MembershipOrderInfoDisplay = React.memo(({ valid, expire_time }) =>
  valid ? (
    <div>
      <div style={{ color: "#5995da" }}>
        <b>您是题库Pro会员，可观看题库内所有视频解答！</b>
      </div>
      <div style={{ color: "grey" }}>
        有效期至
        {expire_time}
      </div>
    </div>
  ) : (
    <div>
      您的题库Pro会员已过期，
      <Link to="/info/product_membership/1">前往续费</Link>
    </div>
  )
);
const ListOrderInfoDisplay = React.memo(({ valid, expire_time, list_id }) =>
  valid ? (
    <div>
      <div style={{ color: "#5995da" }}>
        <b>您已购买此题单，可观看此题单内所有视频解答！</b>
      </div>
      <div style={{ color: "grey" }}>
        有效期至
        {expire_time}
      </div>
    </div>
  ) : (
    <div>
      您购买的题单已过期，
      <Link to={`/checkout/recruitment_question_lists/${list_id}/renew`}>
        前往续费
      </Link>
    </div>
  )
);

function RecruitmentQuestionListDetailPage() {
  const { listId } = useParams();
  const [list, setList] = useState(null);
  useEffect(() => {
    httpclient
      .getOneRecruitmentQuestionListWithQuestionInfo(listId)
      .then((l) => setList(l));
  }, [listId]);

  const hasVideoAccess =
    list?.order_info.product_membership.valid ||
    list?.order_info.recruitment_question_list.valid;

  return (
    <div className="recruitment-question-list-detail">
      <div className="recruitment-question-list-detail-wrapper">
        {list ? (
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                margin: "32px 0",
              }}
            >
              <h1 style={{ fontWeight: "bold" }}>{list.title}</h1>
              <div style={{ marginBottom: 24 }}>{list.description}</div>
              {!!list.can_take_exam && (
                <div className="take-exam">
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => {
                      Modal.confirm({
                        width: 600,
                        title: "是否开始模拟笔试？",
                        closable: true,
                        maskClosable: true,
                        content: (
                          <Typography>
                            <Typography.Paragraph>
                              模拟笔试场景作答本题单，将记录您的作答用时与结果。
                            </Typography.Paragraph>
                            <Typography.Paragraph>
                              模拟笔试总计100分，限时60分钟，具体评分规则：
                              <br />
                              <ul>
                                <li>
                                  单选题30题，每题2分，总计60分；选对得2分，选错得0分。
                                </li>
                                <li>
                                  多选题10题，每题4分，总计40分；全部选对得4分，部分选对得2分，有选错得0分。
                                </li>
                              </ul>
                            </Typography.Paragraph>
                            <Typography.Paragraph>
                              每次将从题单中随机抽取30道单选题、10道多选题进行组卷。点击下方按钮即刻开始模拟笔试。
                            </Typography.Paragraph>
                          </Typography>
                        ),
                        okText: "开始模拟笔试",
                        okButtonProps: {
                          disabled: !list?.order_info.product_membership.valid,
                        },
                        onOk: () => {
                          window.open(
                            `/recruitment-question-exams/${list.id}`,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        },
                        cancelText: "题库Pro会员福利，前往了解",
                        cancelButtonProps: {
                          style: list?.order_info.product_membership.valid
                            ? { display: "none" }
                            : {},
                          type: "link",
                          onClick: () => {
                            window.open(
                              "/info/product_membership/1",
                              "_blank",
                              "noopener,noreferrer"
                            );
                            Modal.destroyAll();
                          },
                        },
                      });
                    }}
                  >
                    <b>进行模拟笔试</b>
                  </Button>
                </div>
              )}
              {listId !== "6" && (
                <>
                  {!hasVideoAccess ? (
                    <div>
                      <div
                        style={{
                          textAlign: "center",
                          marginBottom: 8,
                          color: "#5995da",
                        }}
                      >
                        <b>观看视频解答？</b>
                      </div>
                      <Space>
                        <NavLink
                          to={`/checkout/recruitment_question_lists/${listId}`}
                        >
                          <Button style={{ minHeight: "2.5rem" }}>
                            <Space align="center">
                              <span>￥{list.price / 100}/年</span>
                              <b style={{ fontSize: 16 }}>解锁题单</b>
                            </Space>
                          </Button>
                        </NavLink>
                        或
                        <NavLink to={`/info/product_membership/1`}>
                          <Button style={{ minHeight: "2.5rem" }}>
                            <Space align="center">
                              <span>开通</span>
                              <b style={{ fontSize: 16 }}>题库Pro会员</b>
                            </Space>
                          </Button>
                        </NavLink>
                      </Space>
                    </div>
                  ) : (
                    <Space direction="vertical" style={{ textAlign: "center" }}>
                      {!!list.order_info.product_membership.valid && (
                        <MembershipOrderInfoDisplay
                          valid={list.order_info.product_membership.valid}
                          expire_time={
                            list.order_info.product_membership.record
                              .expire_time
                          }
                        />
                      )}
                      {!list.order_info.product_membership.valid &&
                        !!list.order_info.recruitment_question_list.valid && (
                          <ListOrderInfoDisplay
                            list_id={list.id}
                            valid={
                              list.order_info.recruitment_question_list.valid
                            }
                            expire_time={
                              list.order_info.recruitment_question_list.record
                                .expire_time
                            }
                          />
                        )}
                    </Space>
                  )}
                </>
              )}
            </div>
            <div className="recruitment-question-list-detail-content-wrapper">
              <div className="list-questions">
                <RecruitmentQuestionList list={list} />
              </div>
              <div className="recruitment-sidebar">
                <div className="recruitment-sidebar-inner">
                  <RelatedNodesDisplay related_nodes={list.related_nodes} />
                  {!!list.can_take_exam && hasVideoAccess && (
                    <>
                      <br />
                      <LatestExamRecordsDisplay listId={listId} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              minHeight: "70dvh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </div>
        )}
      </div>
    </div>
  );
}

export default RecruitmentQuestionListDetailPage;
